import { useState } from 'react';
import { USE_MOCK, API_BASE, MOCK_DB, mockDelay, PAGE_SIZE } from '@/utils/constants';
import { authHeader } from '@/utils/api';
import axios from 'axios';
import { httpErrorHandler } from '../utils/httpErrorHandler';
import useSnackbar from './useSnackbar';

export const useChat = () => {
	const [chatIds, setChatIds] = useState([]);
	const [messages, setMessages] = useState([]);
	const [currentChatIndex, setCurrentChatIndex] = useState(-2);

	const [isTypingChatIndex, setIsTypingChatIndex] = useState(-1);

	const [firstQueries, setFirstQueries] = useState([]);
	const [visibleChatCount, setVisibleChatCount] = useState(PAGE_SIZE);
	const [isLoadingMoreChats, setIsLoadingMoreChats] = useState(false);
	const [askWeb, setAskWeb] = useState(false)

	const { showSnackbar } = useSnackbar()

	const setMessagesCallBack = (value) => {
		setMessages(value)
	}

	const handleNewChat = () => {
		if (USE_MOCK) {
			const chatId = `c${MOCK_DB.nextId++}`;
			MOCK_DB.chats.push(chatId);
			MOCK_DB.store[chatId] = { messages: [] };
			setChatIds((p) => [...p, chatId]);
			setCurrentChatIndex(chatIds.length);
			setMessages([]);
			return;
		}

		const emptyChatIndex = chatIds.findIndex(item => item === '')
		
		if (emptyChatIndex >= 0) {
			setCurrentChatIndex(emptyChatIndex)
		} else {
			setCurrentChatIndex(chatIds.length);
		}
		setMessages([]);
		setAskWeb(false);
	};

	const fetchChatList = async () => {
		if (USE_MOCK) {
			await mockDelay(200);
			setChatIds([...MOCK_DB.chats]);
			if (MOCK_DB.chats.length > 0) {
				setCurrentChatIndex(0);
				setMessages([...MOCK_DB.store[MOCK_DB.chats[0]].messages]);
			}
			return;
		}

		axios.get(`${API_BASE}/chat/`, { headers: { ...authHeader() } })
			.then(res => {
				const chats = res.data?.chats || []
				const ids = chats.map(chat => (chat.id))

				if (ids.length > 0) {
					setChatIds(ids);
					setVisibleChatCount(ids.length)
				}			
				
				const firstQueryList = res.data?.chats?.map((chat) => {
					const messages = chat.messages ?? [];

					if (!messages.length) return '';

					let currentMessage = messages[0];

					while (true) {
						const editedMessage = messages
							.slice()
							.reverse()
							.find(
								(message) =>
									message.parent_id ===
									(currentMessage._id ?? currentMessage.id)
							);

						if (!editedMessage) break;

						currentMessage = editedMessage;
					}

					return currentMessage.query;
				});

				setFirstQueries(firstQueryList);		
			})
			.catch(err => {
				httpErrorHandler({
					err: err,
					setSnackbar: (s) => showSnackbar(s?.message || '', { type: s?.type || 'error' })
				})
				console.error('Failed to fetch chat list:', err);
			})
	};

	const handleSidebarScroll = (e) => {
		const el = e.currentTarget;
		const nearBottom = el.scrollHeight - el.scrollTop - el.clientHeight < 48;

		if (nearBottom && !isLoadingMoreChats && visibleChatCount < chatIds.length) {
			setIsLoadingMoreChats(true);
			setTimeout(() => {
				setVisibleChatCount((c) => Math.min(c + PAGE_SIZE, chatIds.length));
				setIsLoadingMoreChats(false);
			}, 1000);
		}
	};

	const setCurrentChatIndexCallback = (index) => {
		setCurrentChatIndex(index)
	}

	const setChatIdsCallback = (newId) => {
		// setChatIds((prev) => [...prev, newId])
		setChatIds((prev) => {
			const emptyChatIndex = prev.findIndex(item => item === '')
			if (emptyChatIndex >= 0) {
				prev[emptyChatIndex] = newId
				return prev
			}

			return [...prev, newId]
		})
	}

	const setVisibleChatCountCallback = (count) => {
		setVisibleChatCount(count)
	}

	return {
		messages,
		setMessages,
		currentChatIndex,
		setCurrentChatIndex,		
		isTypingChatIndex,
		setIsTypingChatIndex,
		chatIds,
		setChatIds,
		visibleChatCount,
		isLoadingMoreChats,
		handleNewChat,
		handleSidebarScroll,
		fetchChatList,
		setMessagesCallBack,
		setCurrentChatIndexCallback,
		setChatIdsCallback,
		setVisibleChatCountCallback,
		firstQueries,
		setFirstQueries,
		askWeb, 
		setAskWeb
	};
};